module.exports = [{"id":"AIR","text":"AIR","color":"##FF808"},{"id":"Disposal","text":"Disposal","color":"##64646"},{"id":"Not going","text":"Not going"},{"id":"Optional","text":"Optional"},{"id":"Sea Freight","text":"Sea Freight","color":"##7CD7F"},{"id":"Storage","text":"Storage","color":"##BF8F0"},{"id":"Truck","text":"Truck","color":"##BFF28"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/Modes.json
// module id = 479
// module chunks = 4